"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Play } from "lucide-react";
export default function DigitalDecorTeaser() {
  return <section id="digital-decor-teaser" className="bg-card text-foreground py-24 lg:py-32 overflow-hidden relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h2 className="text-primary font-serif text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase">
              Precision Printing Meets <br />
              <span className="text-secondary">Cinematic Artistry</span>
            </h2>
            <p className="text-muted-foreground font-sans text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              From professional wedding portraits to industrial-scale cloth prints on our Canon Pro 6600. 
              We bridge the gap between digital vision and physical masterpiece.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary text-primary hover:bg-primary/10 transition-all duration-300 group">
              <Link to="/ArtDecorShopPage" className="flex items-center gap-2">
                Explore the Shop
                <ArrowRight className="size-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            
            <Button asChild variant="ghost" size="lg" className="w-full sm:w-auto text-secondary hover:text-secondary/80 group">
              <Link to="/CustomSceneriesPage" className="flex items-center gap-2">
                <div className="size-8 rounded-lg bg-secondary/10 flex items-center justify-center group-hover:bg-secondary/20 transition-colors">
                  <Play className="size-4 fill-current" />
                </div>
                Custom Frame Studio
              </Link>
            </Button>
          </div>

          <div className="pt-12 grid grid-cols-2 md:grid-cols-4 gap-8 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
            {}
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs font-mono uppercase tracking-widest">Canon Pro 6600</span>
              <div className="h-px w-12 bg-primary" />
            </div>
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs font-mono uppercase tracking-widest">Large Scale</span>
              <div className="h-px w-12 bg-primary" />
            </div>
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs font-mono uppercase tracking-widest">Cinematic 4K</span>
              <div className="h-px w-12 bg-primary" />
            </div>
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs font-mono uppercase tracking-widest">Riyadh Studio</span>
              <div className="h-px w-12 bg-primary" />
            </div>
          </div>
        </div>
      </div>
      
      {}
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 size-96 bg-primary/5 rounded-lg blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/4 size-96 bg-secondary/5 rounded-lg blur-3xl pointer-events-none" />
    </section>;
}